/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

import Calendar from './calendar/th_TH';
import DatePicker from './date-picker/th_TH';
import Pagination from './pagination/th_TH';
import TimePicker from './time-picker/th_TH';

export default {
  locale: 'th',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'à¸à¸±à¸§à¸à¸£à¸­à¸',
    filterConfirm: 'à¸¢à¸·à¸à¸¢à¸±à¸',
    filterReset: 'à¸£à¸µà¹à¸à¹à¸',
    selectAll: 'à¹à¸¥à¸·à¸­à¸à¸à¸±à¹à¸à¸«à¸¡à¸à¹à¸à¸«à¸à¹à¸²à¸à¸µà¹',
    selectInvert: 'à¹à¸¥à¸·à¸­à¸à¸ªà¸à¸²à¸à¸°à¸à¸£à¸à¸à¸±à¸à¸à¹à¸²à¸¡'
  },
  Modal: {
    okText: 'à¸à¸à¸¥à¸',
    cancelText: 'à¸¢à¸à¹à¸¥à¸´à¸',
    justOkText: 'à¸à¸à¸¥à¸'
  },
  Popconfirm: {
    okText: 'à¸à¸à¸¥à¸',
    cancelText: 'à¸¢à¸à¹à¸¥à¸´à¸'
  },
  Transfer: {
    searchPlaceholder: 'à¸à¹à¸à¸«à¸²',
    itemUnit: 'à¸à¸´à¹à¸',
    itemsUnit: 'à¸à¸´à¹à¸'
  },
  Upload: {
    uploading: 'à¸à¸³à¸¥à¸±à¸à¸­à¸±à¸à¹à¸«à¸¥à¸...',
    removeFile: 'à¸¥à¸à¹à¸à¸¥à¹',
    uploadError: 'à¹à¸à¸´à¸à¸à¹à¸­à¸à¸´à¸à¸à¸¥à¸²à¸à¹à¸à¸à¸²à¸£à¸­à¸±à¸à¹à¸«à¸¥à¸',
    previewFile: 'à¸à¸¹à¸à¸±à¸§à¸­à¸¢à¹à¸²à¸à¹à¸à¸¥à¹'
  },
  Empty: {
    description: 'à¹à¸¡à¹à¸¡à¸µà¸à¹à¸­à¸¡à¸¹à¸¥'
  }
};
